// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2vkxX","title":"InfoRow_title__3mLXQ"};